module.exports = __webpack_public_path__ + "static/media/logo_pinterest.bcf52d01.svg";